import {
  buildClassicWorkspacesNewPath,
  CHOOSE_ORGANIZATION_PATH,
} from "./classic-path"
import { hasOrganizationId } from "./organization-id"

/** Where the org-less `/organizations/new` route lives. */
export const NEW_ORGANIZATION_PATH = "/organizations/new"

export interface LegacyWorkspacesNewRedirectArgs {
  /** `?organization_id=` from the legacy `/workspaces/new` URL, if any. */
  organizationIdParam?: string | null
  /** The user's organizations, once `useOrganizations()` has resolved. */
  organizations: Array<{ organization_id: string }> | undefined
  /**
   * React Query's `isPending`, *not* `isLoading`. In v5 `isLoading` is
   * `isPending && isFetching`, so a paused fetch (offline, most commonly)
   * reports `isLoading: false` with no data and no error.
   */
  isPending: boolean
  isError: boolean
}

/**
 * Decides where the legacy `/workspaces/new` URL should go.
 *
 * The create-workspace page is org-scoped now, so it needs an organization.
 * The URL usually carries one (the org overview page links with
 * `?organization_id=`); otherwise the user's first organization is as good a
 * default as the page had before, and a user with no organization has to make
 * one first.
 */
export function decideLegacyWorkspacesNewRedirect({
  organizationIdParam,
  organizations,
  isPending,
  isError,
}: LegacyWorkspacesNewRedirectArgs): string | null {
  if (hasOrganizationId(organizationIdParam)) {
    return buildClassicWorkspacesNewPath(organizationIdParam)
  }

  if (isPending) return null
  if (isError) return CHOOSE_ORGANIZATION_PATH
  if (organizations == null) return null

  const firstOrganizationId = organizations[0]?.organization_id
  if (!hasOrganizationId(firstOrganizationId)) return NEW_ORGANIZATION_PATH

  return buildClassicWorkspacesNewPath(firstOrganizationId)
}
